import React from 'react';
import styles from './allCategoriesList.module.scss.js';

/* eslint-disable camelcase */
function AllCategoriesList(_ref) {
  let {
    items,
    tracking,
    pageType,
    edition,
    useClickTracking,
    baseUrl
  } = _ref;
  const columns = items.reduce((columnsWithItems, item) => {
    // first 5 items has own column, other items display in last column
    if (edition === 'en-us' && item.order > 6) {
      columnsWithItems[6].push(item);
    } else {
      columnsWithItems[item.order] = [item];
    }
    return columnsWithItems;
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `${styles.allCategoriesListWrapper} ${pageType !== 'default' ? styles.allCategoriesListWrapperCategoryPage : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles.allCategoriesListContainer} ${styles[edition]}`
  }, columns.map((column, index) => {
    return /*#__PURE__*/React.createElement(AllCategoriesColumn, {
      tracking: tracking,
      categories: column,
      key: index,
      index: index,
      edition: edition,
      useClickTracking: useClickTracking,
      baseUrl: baseUrl
    });
  }))));
}
function AllCategoriesColumn(_ref2) {
  let {
    categories,
    index,
    tracking,
    edition,
    useClickTracking,
    baseUrl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    key: `acc-${index}`,
    className: `${styles.allCategoriesColumn} ${styles[edition]}`
  }, categories.map((category, cIndex) => {
    return /*#__PURE__*/React.createElement(CategoryListItem, {
      category: category,
      tracking: tracking,
      key: `aci-${cIndex}`,
      columNumber: index,
      edition: edition,
      useClickTracking: useClickTracking,
      baseUrl: baseUrl
    });
  }));
}
function CategoryListItem(_ref3) {
  let {
    category,
    tracking,
    columNumber,
    edition,
    useClickTracking,
    baseUrl
  } = _ref3;
  let href = category.link.includes('giftguide') ? category.link : `${baseUrl}/${category.link}`;
  if (category.full_link) {
    href = category.link;
  }
  const children = category.children ? category.children.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }) : [];
  const ref = useClickTracking({
    ...tracking,
    subunit_type: 'component',
    subunit_name: 'all_categories_list',
    position_in_unit: columNumber,
    position_in_subunit: 1,
    item_type: 'text',
    item_name: category.name,
    target_content_type: 'url',
    target_content_id: href,
    target_content_url: href
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.aci
  }, /*#__PURE__*/React.createElement("a", {
    ref: ref,
    href: href,
    className: ` ${styles.aciParent} ${styles[edition]}`
  }, category.name), children.map((child, childIndex) => {
    return /*#__PURE__*/React.createElement(SubCategoryListItem, {
      tracking: tracking,
      category: child,
      parentLink: href,
      key: `acic-${childIndex}`,
      columNumber: columNumber,
      index: childIndex,
      useClickTracking: useClickTracking
    });
  }));
}
function SubCategoryListItem(_ref4) {
  let {
    category,
    parentLink,
    tracking,
    columNumber,
    index,
    useClickTracking
  } = _ref4;
  const parentHref = parentLink.split('?')[0];
  const childHref = `${parentHref}/${category.link}`;
  const ref = useClickTracking({
    ...tracking,
    subunit_type: 'component',
    subunit_name: 'all_sub_categories_list',
    position_in_unit: columNumber,
    position_in_subunit: index + 2,
    item_type: 'text',
    item_name: category.name,
    target_content_type: 'url',
    target_content_id: childHref,
    target_content_url: childHref
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.aciChildWrap
  }, /*#__PURE__*/React.createElement("a", {
    ref: ref,
    href: childHref,
    className: styles.aciChild
  }, category.name));
}

export { AllCategoriesList, AllCategoriesList as default };
